import type { ReactNode } from "react";
import { animated, config, useSpring } from "@react-spring/web";

interface FadeProps {
  children: ReactNode;
  show: boolean;
}

/**
 * Break glass: the whole component is a react-spring surface. Its opacity is a
 * value the spring recomputes every frame, so it can only reach the DOM as an
 * inline style — there is no Tailwind class for "whatever opacity the spring is
 * at right now".
 */
function Fade(props: FadeProps) {
  const slideInStyles = useSpring({
    config: { ...config.gentle },
    from: { opacity: 0 },
    to: {
      opacity: props.show ? 1 : 0,
    },
  });
  return (
    <animated.div style={{ ...slideInStyles, overflow: "hidden" }}>
      {props.children}
    </animated.div>
  );
}
export default Fade;
